import React, { useState } from "react";
import { Form, Input, DatePicker, Button, Modal, message, Select } from "antd";
import Get from "../../services/Get";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs"; // Import dayjs for date formatting

const ViewAttendance = ({ isAttOpen, setIsAttOpen, type }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [classFilter, setClassFilter] = useState("Pre-Nursery");
  const [sectionFilter, setSectionFilter] = useState("A");

  console.log(type);

  const handleClassChange = (value) => {
    setClassFilter(value);
  };

  const handleSectionChange = (value) => {
    setSectionFilter(value);
  };

  const classOptions = [
    "Pre-Nursery",
    "Nursery",
    "KG",
    "LKG",
    "UKG",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ].map((className) => ({
    label: className,
    value: className,
  }));

  const sectionOptions = [
    ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)),
  ].map((letter) => ({
    label: letter,
    value: letter,
  }));

  const onFinish = (values) => {
    setLoading(true);

    // Format date before sending request
    const formattedValues = {
      ...values,
      date: values.date ? dayjs(values.date).format("YYYY-MM-DD") : null,
    };

    type == "student"
      ? Get.getStudents(
          formattedValues.class,
          formattedValues.section,
          formattedValues.date
        )
          .then((res) => {
            navigate("/user/attendance", { state: { data: res.data } });
            console.log(res);
          })
          .catch((error) => {
            message.error(error);
          })
          .finally(() => {
            setIsAttOpen(false);
            setLoading(false);
          })
      : Get.getAttendance(formattedValues.date, type)
          .then((res) => {
            navigate("/user/attendance", { state: { data: res.data } });
            console.log(res);
          })
          .catch((error) => {
            message.error(error);
          })
          .finally(() => {
            setIsAttOpen(false);
            setLoading(false);
          });
  };

  return (
    <Modal
      title="View Attendance"
      open={isAttOpen}
      onCancel={() => setIsAttOpen(false)}
      footer={null}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        initialValues={{
          class: classFilter,
          section: sectionFilter,
        }}
      >
        {type === "student" && (
          <>
            <Form.Item
              label="Class"
              name="class"
              rules={[{ required: true, message: "Please input the class!" }]}
            >
              {/* <Input placeholder="Enter class" /> */}
              <Select
                size="middle"
                onChange={handleClassChange}
                style={{
                  width: "100%",
                }}
                value={classFilter}
                options={classOptions}
              />
            </Form.Item>

            <Form.Item
              label="Section"
              name="section"
              rules={[{ required: true, message: "Please input the section!" }]}
            >
              {/* <Input placeholder="Enter section" /> */}
              <Select
                size="middle"
                onChange={handleSectionChange}
                style={{
                  width: "100%",
                }}
                value={sectionFilter}
                options={sectionOptions}
              />
            </Form.Item>
          </>
        )}

        <Form.Item
          label="Date"
          name="date"
          rules={[{ required: true, message: "Please select the date!" }]}
        >
          <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="form-btn"
            loading={loading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ViewAttendance;
